import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../types/store';

import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { Props } from './Donations';

type StateProps = Pick<
  Props,
  | 'title'
  | 'description'
  | 'goal'
  | 'amount'
  | 'donors'
  | 'username'
  | 'userUuid'
  | 'isOwner'
  | 'moduleVersion'
>;

type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const user = getProfileOwnerUser(state);
  const {
    title,
    textContent: description,
    donors = 0,
    amount = 0,
    goal = 100,
  } = moduleData;
  return {
    title,
    donors,
    amount,
    goal,
    description,
    isOwner: isCurrentUserProfileOwner(state),
    username: user.username,
    userUuid: user.useridUuid,
    moduleVersion,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = () => ({});

export default connect(mapStateToProps, mapDispatchToProps);
